<template>
  <div>
    <v-alert v-if="sorted_all_rule_slot.length === 0" type="warning" text dense class="mb-4">
      ยังไม่มีเงื่อนไข นักศึกษาทุกคนในสถาบันสามารถลงทะเบียนวิชานี้ได้
      หากต้องการจำกัดสิทธิ์ ให้เพิ่มเงื่อนไขด้านล่าง
    </v-alert>
    <v-simple-table v-else dense class="mb-4">
      <template v-slot:default>
        <tbody>
          <tr v-for="(item, index) in sorted_all_rule_slot" :key="index">
            <td>{{ index + 1 }}.</td>

            <td>
              {{ item.subject_rule_type_detail }}
            </td>

            <td
              v-if="
                item.subject_rule_type_id == '3' ||
                  item.subject_rule_type_id == '1'
              "
            >
              ตั้งแต่รหัส
            </td>
            <td v-if="item.subject_rule_type_id == '2'">
              {{ $t("home.study_plan") }}
            </td>
            <td v-if="item.subject_rule_type_id == '4'">คณะ</td>
            <td v-if="item.subject_rule_type_id == '5'">คณะ</td>
            <td v-if="item.subject_rule_type_id == '6'">คือรหัส</td>

            <td
              v-if="
                item.subject_rule_type_id == '3' ||
                  item.subject_rule_type_id == '1' ||
                  item.subject_rule_type_id == '6'
              "
            >
              {{ item.start_rule }}
            </td>
            <td
              v-if="
                item.subject_rule_type_id == '2' ||
                item.subject_rule_type_id == '4' ||
                  item.subject_rule_type_id == '5'
              "
            >
              {{ item.start_rule_detail }}
            </td>

            <td
              v-if="
                item.subject_rule_type_id == '3' ||
                  item.subject_rule_type_id == '1'
              "
            >
              ถึง
            </td>
            <td v-if="item.subject_rule_type_id == '4'">สาขา</td>
            <td
              v-if="
                item.subject_rule_type_id == '2' ||
                item.subject_rule_type_id == '5' ||
                  item.subject_rule_type_id == '6'
              "
            ></td>

            <td
              v-if="
                item.subject_rule_type_id == '3' ||
                  item.subject_rule_type_id == '1'
              "
            >
              {{ item.end_rule }}
            </td>
            <td v-if="item.subject_rule_type_id == '4'">
              {{ item.end_rule_detail }}
            </td>
            <td
              v-if="
                item.subject_rule_type_id == '2' ||
                item.subject_rule_type_id == '5' ||
                  item.subject_rule_type_id == '6'
              "
            ></td>

            <td>
              <v-btn small icon color="red" @click="remove_rule_slot(index)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <RuleSlotAdding
      ref="rule_slot_adding"
      :level-id="levelId"
      :current_rule_slots="all_rule_slot"
      :add_new_rule_slot="(data) => add_new_rule_slot(data)"
    />
  </div>
</template>

<script>
import RuleSlotAdding from "./RuleSlotAdding.vue";
import ConfigTeachTableProvider from "@/services/config_teach_table.provider.js";
const ConfigTeachTableService = new ConfigTeachTableProvider();
export default {
  name: "RuleSlot",
  props: {
    levelId: {
      type: [String, Number],
      default: 1,
    },
  },
  data: () => ({
    all_rule_slot: [],
  }),
  computed: {
    sorted_all_rule_slot() {
      let all_rule_slot = this.all_rule_slot;
      return all_rule_slot;
    },
  },
  components: {
    RuleSlotAdding,
  },
  methods: {
    async add_new_rule_slot(new_rule_slot) {
      this.all_rule_slot = [...this.all_rule_slot, ...new_rule_slot];
    },
    remove_rule_slot(index) {
      this.all_rule_slot.splice(index, 1);
    },
    async save_to_db(level_id, teach_table_id) {
      const response = await ConfigTeachTableService.setRuleSlot({
        level_id,
        teach_table_id,
        all_rule_slot: this.all_rule_slot,
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        return null;
      });

      if (response && response.status) {
        this.$toasted.success(
          this.$t("config_teach_table.save_rule_slot_successfully"),
          {
            duration: 0,
          }
        );
        return true;
      }
      return false;
    },
    async get_rule_slot(level_id, teach_table_id) {
      const data = await ConfigTeachTableService.getRuleSlot({
        level_id,
        teach_table_id,
      });
      this.all_rule_slot = [];
      for (const key in data.all_rule_slot) {
        if (Object.hasOwnProperty.call(data.all_rule_slot, key)) {
          const element = data.all_rule_slot[key];
          await this.$refs.rule_slot_adding.check_rule_integrity({
            subject_rule_type_id: element.type,
            con1: element.con1,
            con2: element.con2,
          });
        }
      }
    },
  },
};
</script>
